import styles from "./Button.module.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import PropTypes from 'prop-types';
import { fal } from "@fortawesome/pro-light-svg-icons";
library.add(fal);

const Button = ({ hasBorder, title, isDisabled, variant, hasNoBackground, onClick, hasArrow, className, iconName, type, ...props }) => {
    return (
        <button disabled={isDisabled} type={type} onClick={!isDisabled ? onClick : null} className={[styles.button, styles[variant], className, hasBorder && styles.border, isDisabled && styles.disabled, hasNoBackground && styles.hasNoBackground].filter(e => !!e)
            .join(' ')} {...props}>
            {(hasArrow || iconName != null) && <span className={[styles.arrow, styles[variant], hasNoBackground && styles.hasNoBackground].filter(e => !!e)
                .join(' ')}> {hasArrow ? <FontAwesomeIcon icon={["fal", "arrow-left"]} /> : <FontAwesomeIcon icon={["fal", iconName.replace(/'/g, "")]} />}</span>}
            <p className={styles.label}>{title}</p>
        </button>
    );
}

Button.propTypes = {
    onClick: PropTypes.any.isRequired,
    variant: PropTypes.string.isRequired
}

export default Button;